import { modelOptions, post, prop } from "@typegoose/typegoose";
import { z } from "zod";
import { getZodSchemaFromClass, validate } from "../../../zod-decorator/index.js";
import { addSchemaKeyHook, SchemaBase, getDefaultSchemaOptions, SchemaConstructorArgs } from "../../schemaBase.js";
import { VertexInfo } from "../../commonSubSchemas/vertexInfo.js";
import type { ImageOverlayFieldsWithDefaults, ImageOverlaySchemaTypes } from "../../types/imageOverlay.d.js";
import type { DtoValidatorTypes } from "../../validatableClass.js";

const SCHEMA_KEY = "ImageOverlay" as const;

@modelOptions({ schemaOptions: { ...getDefaultSchemaOptions(SCHEMA_KEY) } })
@post<SchemaBase<ImageOverlay>>(...addSchemaKeyHook(SCHEMA_KEY))
export class ImageOverlay extends SchemaBase<ImageOverlay, ImageOverlayFieldsWithDefaults> {
    static readonly schemaKey = SCHEMA_KEY;
    @validate({ schemaKey: SCHEMA_KEY })
    readonly schemaKey = SCHEMA_KEY;

    @validate({ zodValidator: z.number().optional() })
    @prop({ type: () => Number, required: true, default: 0 })
    public layer: number = 0;

    @validate({ childClass: VertexInfo })
    @prop({ type: () => VertexInfo, required: true })
    public topLeft!: VertexInfo;

    @validate({ childClass: VertexInfo })
    @prop({ type: () => VertexInfo, required: true })
    public botRight!: VertexInfo;

    /**
     * @deprecated
     * use the getImageUrl getter so we can migrate this to a new name
     */
    @validate({ zodValidator: z.string().min(1) })
    @prop({ type: () => String, required: true })
    public img_url!: string;

    static getters = {
        /**
         * Returns the width of the overlay in coordinate units
         */
        getImageUrl: (self: ImageOverlay): string => self.img_url,
    } as const satisfies Record<string, (self: ImageOverlay) => any>;

    static utilities = {} as const satisfies Record<string, (...args: any) => any>;

    static dtoValidators: DtoValidatorTypes<ImageOverlaySchemaTypes>;

    constructor(properties?: SchemaConstructorArgs<ImageOverlay, ImageOverlayFieldsWithDefaults>) {
        super(properties);
        Object.assign(this, properties);
    }
}

ImageOverlay.dtoValidators = getZodSchemaFromClass(
    ImageOverlay,
) as unknown as DtoValidatorTypes<ImageOverlaySchemaTypes>;
